module.exports = __webpack_public_path__ + "img/etnet-20220811.b9374cc9.jpg";